<h1 mat-dialog-title>{{action}}
  <ng-container i18n="Contest Details Modal|Contest Details modal title@@contest-details-modal-title">
    Contest
  </ng-container>
</h1>
<div mat-dialog-content #dialogContent class="full-width details-content">
  <permission-checker [roles]="roles" (contentInit)="initContent()">
    <form [formGroup]="detailsForm" (ngSubmit)="proceed()">
      <form-input [control]="nameField"
                  label="Name"
                  i18n-label="Contest Details Modal|Contest Details modal name input label@@contest-details-modal-name-input-label"
                  placeholder="Contest name..."
                  i18n-placeholder="Contest Details Modal|Contest Details modal name input placeholder@@contest-details-modal-name-input-placeholder"
                  [minLength]="3" [maxLength]="128"></form-input>

      <div class="price">
        <form-input [control]="priceField"
                    type="number"
                    class="price-input"
                    label="Price"
                    i18n-label="Contest Details Modal|Contest Details modal price input label@@contest-details-modal-price-input-label"
                    placeholder="Enrollment price..."
                    i18n-placeholder="Contest Details Modal|Contest Details modal price input placeholder@@contest-details-modal-price-input-placeholder"
                    [min]="0"></form-input>
        <div class="fill-space"></div>
        <mat-slide-toggle [formControl]="paymentRequiredField" color="primary"
                          class="payment-required"
                          [disabled]="readOnlyMode || !priceField.value || priceField.value == 0"
                          i18n="General|Payment required label@@general-payment-required-label">Payment required</mat-slide-toggle>
      </div>

      <div class="editor form-input">
        <mat-label
          i18n="Contest Details Modal|Contest Details modal description input label@@contest-details-modal-description-input-label">
          Description
        </mat-label>
        <editor *ngIf="initEditor"
                [formControl]="descriptionField"
                [apiKey]="editorApiKey"
                [init]="editorConfig"
                [disabled]="descriptionField.disabled || readOnlyMode"></editor>
        <mat-error *ngIf="descriptionField.hasError('maxlength') && descriptionField.dirty"
                   class="mat-small">
          <ng-container
            i18n="Form Validation|Invalid contest description max length@@form-validation-input-invalid-contest-description-max">
            Description HTML code should contain less than 3072 characters
          </ng-container>
        </mat-error>
      </div>

      <div class="editor form-input">
        <mat-label
          i18n="Contest Details Modal|Contest Details modal instructions input label@@contest-details-modal-instructions-input-label">
          Instructions
        </mat-label>
        <editor *ngIf="initEditor"
                [formControl]="instructionsField"
                [apiKey]="editorApiKey"
                [init]="instructionsEditorConfig"
                [disabled]="instructionsField.disabled || readOnlyMode"></editor>
        <mat-error *ngIf="instructionsField.hasError('maxlength') && instructionsField.dirty"
                   class="mat-small">
          <ng-container
            i18n="Form Validation|Invalid contest instructions max length@@form-validation-input-invalid-contest-instructions-max">
            Instructions HTML code should contain less than 3072 characters
          </ng-container>
        </mat-error>
      </div>

      <div fxLayout="column" class="full-width">
        <div fxLayout="row" fxLayout.lt-sm="column" class="enrol-date-range">
          <div fxFlex="48%" fxFlex.lt-sm="100%">
            <mat-form-field class="full-width form-input">
              <mat-label i18n="Contest Details Modal|Contest Details modal enrolment dates input label@@contest-details-modal-enrolment-dates-input-label">Enrolment Dates</mat-label>
              <mat-date-range-input
                [formGroup]="detailsForm"
                [rangePicker]="enrolPicker"
                [comparisonStart]="startsAtDateField.value"
                [comparisonEnd]="endsAtDateField.value"
                [min]="today"
                [max]="endsAtDateField.value || null">
                <input matStartDate
                       placeholder="Enrol Starts At"
                       i18n-placeholder="Contest Details Modal|Contest Details modal enrol start date input placeholder@@contest-details-modal-enrol-start-date-input-placeholder"
                       readonly
                       [formControl]="enrolStartsAtDateField">
                <input matEndDate
                       placeholder="Enrol Ends At"
                       i18n-placeholder="Contest Details Modal|Contest Details modal enrol end date input placeholder@@contest-details-modal-enrol-end-date-input-placeholder"
                       readonly
                       [formControl]="enrolEndsAtDateField">
              </mat-date-range-input>
              <mat-datepicker-toggle matSuffix [for]="enrolPicker"></mat-datepicker-toggle>
              <mat-date-range-picker #enrolPicker></mat-date-range-picker>
            </mat-form-field>
          </div>
          <div class="fill-space"></div>

          <form-input fxFlex="24%" fxFlex.lt-sm="48%"
                      [control]="enrolStartsAtTimeField"
                      [required]="false"
                      label="Enrol Start Time"
                      i18n-label="Contest Details Modal|Contest Details modal enrol start time input label@@contest-details-modal-enrol-start-time-input-label"
                      type="time"
                      [errorStateMatcher]="enrolMatcher"
                      [formGroup]="detailsForm" timeErrorCode="enrolTimeIncorrect"></form-input>
          <div class="fill-space"></div>
          <form-input fxFlex="24%" fxFlex.lt-sm="48%"
                      [control]="enrolEndsAtTimeField"
                      [required]="false"
                      label="Enrol End Time"
                      i18n-label="Contest Details Modal|Contest Details modal enrol end time input label@@contest-details-modal-enrol-end-time-input-label"
                      type="time"
                      [errorStateMatcher]="enrolMatcher"
                      [formGroup]="detailsForm" timeErrorCode="enrolTimeIncorrect" [timeStart]="false"></form-input>
        </div>

        <div fxLayout="row" fxLayout.lt-sm="column">
          <div fxFlex="48%" fxFlex.lt-sm="100%">
            <mat-form-field class="full-width form-input">
              <mat-label i18n="Contest Details Modal|Contest Details modal contest dates input label@@contest-details-modal-contest-dates-input-label">Contest Dates</mat-label>
              <mat-date-range-input
                [formGroup]="detailsForm"
                [rangePicker]="startPicker"
                [comparisonStart]="enrolStartsAtDateField.value"
                [comparisonEnd]="enrolEndsAtDateField.value"
                [min]="enrolStartsAtDateField.value ? addDays(enrolStartsAtDateField.value, 1) : addDays(today, 1)">
                <input matStartDate
                       placeholder="Starts At"
                       i18n-placeholder="Contest Details Modal|Contest Details modal contest start date input placeholder@@contest-details-modal-contest-start-date-input-placeholder"
                       readonly
                       [formControl]="startsAtDateField">
                <input matEndDate
                       placeholder="Ends At"
                       i18n-placeholder="Contest Details Modal|Contest Details modal contest end date input placeholder@@contest-details-modal-contest-start-end-input-placeholder"
                       readonly
                       [formControl]="endsAtDateField">
              </mat-date-range-input>
              <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
              <mat-date-range-picker #startPicker></mat-date-range-picker>
            </mat-form-field>
          </div>

          <div class="fill-space"></div>

          <form-input fxFlex="24%" fxFlex.lt-sm="48%"
                      [control]="startsAtTimeField"
                      [required]="false"
                      label="Contest Start Time"
                      i18n-label="Contest Details Modal|Contest Details modal contest start time input label@@contest-details-modal-contest-start-time-input-label"
                      type="time"
                      [errorStateMatcher]="startMatcher"
                      [formGroup]="detailsForm" timeErrorCode="startTimeIncorrect"></form-input>
          <div class="fill-space"></div>
          <form-input fxFlex="24%" fxFlex.lt-sm="48%"
                      [control]="endsAtTimeField"
                      [required]="false"
                      label="Contest End Time"
                      i18n-label="Contest Details Modal|Contest Details modal contest end time input label@@contest-details-modal-contest-end-time-input-label"
                      type="time"
                      [errorStateMatcher]="startMatcher"
                      [formGroup]="detailsForm" timeErrorCode="startTimeIncorrect" [timeStart]="false"></form-input>
        </div>
      </div>

      <div class="full-width">
        <form-input [control]="durationField"
                    type="number"
                    label="Duration"
                    i18n-label="Contest Details Modal|Contest Details modal duration input label@@contest-details-modal-duration-input-label"
                    placeholder="Contest duration (in minutes)..."
                    i18n-placeholder="Contest Details Modal|Contest Details modal duration input placeholder@@contest-details-modal-duration-input-placeholder"
                    [min]="1"></form-input>

        <form-input [control]="pointsBalanceField"
                    type="number"
                    label="Initial points balance"
                    i18n-label="Contest Details Modal|Contest Details modal points balance input label@@contest-details-modal-points-balance-input-label"
                    placeholder="Initial participant points balance..."
                    i18n-placeholder="Contest Details Modal|Contest Details modal points balance input placeholder@@contest-details-modal-points-balance-input-placeholder"
                    [min]="0" [max]="200"></form-input>

        <form-input [control]="answerPenaltyField"
                    type="number"
                    label="Wrong answer penalty"
                    i18n-label="Contest Details Modal|Contest Details modal answer penalty input label@@contest-details-modal-answer-penalty-input-label"
                    placeholder="Wrong answer penalty (in percentage from correct points)..."
                    i18n-placeholder="Contest Details Modal|Contest Details modal answer penalty input placeholder@@contest-details-modal-answer-penalty-input-placeholder"
                    [min]="0" [max]="100"></form-input>

        <form-input [control]="excellentRatioField"
                    type="number"
                    label="Excellent passing ratio"
                    i18n-label="Contest Details Modal|Contest Details modal excellent ratio input label@@contest-details-modal-excellent-ratio-input-label"
                    placeholder="Excellent passing ratio (in percentage from participants count)..."
                    i18n-placeholder="Contest Details Modal|Contest Details modal excellent ratio input placeholder@@contest-details-modal-excellent-ratio-input-placeholder"
                    [min]="0" [max]="100"></form-input>
        <form-input [control]="goodRatioField"
                    type="number"
                    label="Good passing ratio"
                    i18n-label="Contest Details Modal|Contest Details modal good ratio input label@@contest-details-modal-good-ratio-input-label"
                    placeholder="Good passing ratio (in percentage from participants count)..."
                    i18n-placeholder="Contest Details Modal|Contest Details modal good ratio input placeholder@@contest-details-modal-good-ratio-input-placeholder"
                    [min]="0" [max]="100"></form-input>
        <form-input [control]="averageRatioField"
                    type="number"
                    label="Average passing ratio"
                    i18n-label="Contest Details Modal|Contest Details modal average ratio input label@@contest-details-modal-average-ratio-input-label"
                    placeholder="Average Passing Ratio (in percentage from participants count)..."
                    i18n-placeholder="Contest Details Modal|Contest Details modal average ratio input placeholder@@contest-details-modal-average-ratio-input-placeholder"
                    [min]="0" [max]="100"></form-input>

        <!-- Exam book -->
        <mat-label i18n="Contest Task|Contest task info label@@contest-task-contest-task-info-label"
                   class="mat-small text-disabled-color">
          Task book
        </mat-label>
        <mat-hint i18n="Contest Task|Contest task info help@@contest-task-contest-task-info-help"
            class="mat-small text-disabled-color task-info-help">
          (it will be available to participants after the contest ends, and results are calculated)
        </mat-hint>

        <file-upload *ngIf="!contest?.taskInfoUrl" acceptTypes=".pdf" fileTypes="*.pdf"
                     (fileSelected)="taskBookSelected($event)"></file-upload>
        <div *ngIf="contest && contest.taskInfoUrl" class="task-book-holder">
          <app-button icon="delete" [secondary]="true" [destructive]="true" class="delete-book-btn"
                      (clicked)="contest.taskInfoUrl = undefined; $event.preventDefault();"></app-button>
          <app-link icon="auto_stories"
                    label="tasks book"
                    i18n-label="Stats Dashboard|Exam Card tasks book title@@stats-dashboard-exam-card-tasks-book-title"
                    [href]="contest.taskInfoUrl"
                    [external]="true"></app-link>
        </div>
        <!--  Exam book end  -->
      </div>
    </form>
  </permission-checker>
</div>
<div mat-dialog-actions>
  <app-button *ngIf="!readOnlyMode"
              [disabled]="inProgress"
              (clicked)="closeModal()"
              [secondary]="true"
              label="Cancel"
              i18n-label="General|Cancel action label@@general-cancel-action-label"></app-button>
  <span class="btn-spacer"></span>
  <app-button *ngIf="!readOnlyMode"
              [disabled]="inProgress || !proceedAllowed()"
              (clicked)="proceed()"
              [label]="action"></app-button>
  <app-button *ngIf="readOnlyMode"
              [disabled]="inProgress"
              (clicked)="closeModal()"
              [secondary]="true"
              label="Close"
              i18n-label="General|Close action label@@general-close-action-label"></app-button>
</div>
